import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

Vue.config.productionTip = false

// Fonts (Gibson)
import "@/assets/sass/fonts.scss";

// Bootstrap config
import "@/assets/sass/bootstrap.scss";

// Mapbox styles
// import "@/assets/sass/mapbox.scss";

// Font Awesome
require('./services/fontAwesome.js')

// Bootstrap
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

// Tooltip
import VueTippy from "vue-tippy";
Vue.use(VueTippy);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

